module.exports = __webpack_public_path__ + "img/chatbot-3.93d93361.png";